import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ExperienceCards";
import Particle from "../Particle";

function Experience() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Professional <strong className="purple">Journey </strong>
        </h1>
        <p style={{ color: "white" }}>
          From fintech trading systems to Fortune 25 GenAI pipelines — here's
          where I've made an impact.
        </p>
        <Row>
          <Col>
            <Row style={{ justifyContent: "center" }}>
              <h2 className="project-subheading">Work Experience</h2>

              <Col
                md={12}
                className="project-card"
                style={{ marginBottom: "20px" }}
              >
                <ProjectCard
                  title="Generative AI Engineer – Kroger, Fortune 25 (via CloudIngest)"
                  duration="Apr 2025 – Present · Cincinnati, OH"
                  description="Building GenAI data pipelines using LangChain 0.3 and GPT-4o to connect LLM outputs to live retail workflows across 5+ backend services, cutting manual processing time by 32%. Set up Databricks workflows processing millions of transactions daily, reducing pipeline execution time by 38%."
                  description2="Took ownership of a Voice AI project for customer call automation using Python and FastAPI. Tuned Spring Boot services and rewrote slow SQL queries, achieving ~40% improvement in query execution time. Work closely with data science in Agile sprints to ship production-ready AI features."
                  keywords="Java 21 | Python 3.12 | Spring Boot 3.4 | LangChain 0.3 | OpenAI GPT-4o | Databricks | FastAPI | AWS | Voice AI"
                />
              </Col>

              <Col
                md={12}
                className="project-card"
                style={{ marginBottom: "20px" }}
              >
                <ProjectCard
                  title="Generative AI Engineer – TeamCal AI, AI Scheduling Platform"
                  duration="Apr 2023 – Apr 2025 · Mountain View, CA (Remote)"
                  description="Integrated OpenAI GPT-4 and GPT-3.5 into Spring Boot backend to power scheduling suggestions, email drafts, and smarter user interactions. Built LangChain pipelines tying AI outputs to live calendar data — scheduling conflicts dropped 43%. Handled both sides of the stack: React 18 with TypeScript frontend, Spring Boot 3.x with GraphQL and REST backend."
                  description2="Owned auth layer (Spring Security, JWT, OAuth 2.0) across multi-tenant enterprise setup. Rewrote PostgreSQL and MongoDB schemas bottlenecking under concurrent load — read speeds improved 42%. Built CI/CD pipeline from scratch with Jenkins, GitHub Actions, Docker on AWS ECS and Kubernetes — deployments 53% faster. Maintained 90%+ test coverage."
                  keywords="Java 17 | Spring Boot 3.x | OpenAI GPT-4 | LangChain | React 18 | TypeScript | GraphQL | Redis 7 | PostgreSQL 15 | MongoDB 6 | Docker | K8s | AWS ECS"
                />
              </Col>

              <Col
                md={12}
                className="project-card"
                style={{ marginBottom: "20px" }}
              >
                <ProjectCard
                  title="Software Engineer – DriveWealth (via Ionixx Technologies)"
                  duration="Jan 2021 – Sep 2022 · Chennai, India"
                  description="Rewrote ~30% of REST APIs on DriveWealth's trading platform using Spring Boot 2.6 and WebFlux. Led migration to microservices with Spring Cloud across 8+ trading modules. Built real-time data pipelines using Kafka 3.x, gRPC, and GraphQL — inter-service throughput up 58%."
                  description2="Implemented async handling for trading requests using Java Concurrency API and CompletableFuture — response times dropped 44% under heavy load. Set up OAuth 2.0 and JWT-based role access with React 17 frontend permission rendering."
                  keywords="Java 11 | Spring Boot 2.6 | Spring WebFlux | Spring Cloud | Kafka 3.x | gRPC | GraphQL | PostgreSQL 13 | MySQL 8 | React 17"
                />
              </Col>

              <Col
                md={12}
                className="project-card"
                style={{ marginBottom: "20px" }}
              >
                <ProjectCard
                  title="Software Developer – FXMKT Technologies"
                  duration="Dec 2020 – Jan 2021 · Chennai, India"
                  description="Led 85% of development for the Custom Cloth e-commerce platform, implementing microservices architecture with Java, Spring Boot, and CI/CD pipelines. Developed client-tier features including shopping cart using TypeScript and ES6."
                  description2="Applied distributed systems design patterns to reduce page load times and support high-traffic scenarios. Automated testing and deployment workflows through CI/CD pipelines."
                  keywords="Java | Spring Boot | Microservices | TypeScript | ES6 | E-commerce | CI/CD"
                />
              </Col>
            </Row>
          </Col>

          <Col>
            <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
              <h2 className="project-subheading">Notable Projects</h2>

              <Col md={12} className="project-card">
                <ProjectCard
                  title="Voycee: AI Voice Assistance Platform"
                  description="Built end-to-end — a Voice AI system that automates inbound calls for restaurants and hospitals. Handles reservations, appointment booking, order status checks, department routing, and FAQs. Supports English and Spanish with a real-time analytics dashboard. Missed calls during peak hours dropped ~80%."
                  keywords="Python 3.10 | FastAPI | React 18 | Voice AI | Conversational AI"
                />
              </Col>

              <Col
                md={12}
                className="project-card"
                style={{ marginTop: "20px" }}
              >
                <ProjectCard
                  title="LangChain Scheduling Intelligence – TeamCal AI"
                  description="Production AI pipeline connecting GPT-4 to live calendar data for meeting scheduling, email drafting, and conflict resolution. Shipped to real enterprise customers on the TeamCal platform."
                  keywords="LangChain | OpenAI GPT-4 | Spring Boot 3.x | RAG Architecture"
                />
              </Col>

              <Col
                md={12}
                className="project-card"
                style={{ marginTop: "20px" }}
              >
                <ProjectCard
                  title="FactFinder – Fake News Detection"
                  description="Full-stack ML classification app handling 7,000+ concurrent users with a real-time prediction API. Focused on deployment and infrastructure for production readiness."
                  keywords="Python 3.10 | Flask 2.x | React 18 | AWS ECS | Machine Learning"
                />
              </Col>

              <Col
                md={12}
                className="project-card"
                style={{ marginTop: "20px", marginBottom: "20px" }}
              >
                <ProjectCard
                  title="Wazrix-bot – Trading Algorithm"
                  description="AI-powered trading algorithm for WazirX. Leverages real-time market data and intelligent predictions to maximize profits."
                  keywords="Python | Flask | JavaScript"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Experience;
